































import Vue from "vue";
import gsap from "gsap";

export default Vue.extend({
  name: "InfoProject",
  props: {
    listInfo: Array,
  },
  data() {
    return {
      number: this.$props.listInfo.map(() => 0),
      tweenedNumber: this.$props.listInfo.map(() => 0),
    };
  },
  computed: {
    animatedNumber(): string {
      try {
        if (!Array.isArray(this.tweenedNumber)) {
          return this.tweenedNumber
            .split(",")
            .map((x: string) => parseInt(x).toFixed(0));
        }
      } catch (error) {
        console.log(error);
      }

      return this.tweenedNumber.map((x: number) => x.toFixed(0));
    },
  },
  watch: {
    number(newValue) {
      gsap.to(this.$data, {
        duration: 1,
        tweenedNumber: newValue,
      });
    },
  },
  created() {
    setTimeout(() => {
      this.number = this.$props.listInfo.map(({ total }: any) => total);
    }, 1000);
  },
});
